const nav_search_list = document.querySelectorAll('.js_nav_search_box')

function handleClickOutside(specifiedElement, elToChange, isListening) {
    var myClick = (function () {
        var handler = function (e) {
            const isClickInside = specifiedElement.contains(e.target)

            if (!isClickInside) {
                // console.log('outside!');
                elToChange.classList.remove('active')
                document.removeEventListener('click', handler);
            } else {

                // console.log('Inside!');
            }
        };
        return handler;
    })();

    if (!isListening) {
        document.addEventListener('click', myClick);
    }
}

function initNavBarSearch(el) {
    const search_btn = el.querySelector('.js_nav_search_btn')
    const form_el = el.querySelector('.js_nav_search_form_box')

    search_btn.addEventListener('click', function () {

        if (el.classList.contains('active')) {
            el.classList.remove('active')
            handleClickOutside(form_el, el, true)
        } else {
            el.classList.add('active')
            setTimeout(function () {
                handleClickOutside(form_el, el, false)
            }, 0)
        }
    })
}


if (nav_search_list.length) {
    for (var i = 0; i < nav_search_list.length; i++) {
        const element = nav_search_list[i]
        initNavBarSearch(element)
    }
}

